import Dispatcher from '../dispatcher';
import Honeybadger from 'honeybadger-js';

const UserStore = {

  _state: undefined,

  isLoading: false,

  get() {
    this._load();
    return this._state;
  },

  _updateState(state){
    this._state = state;
    Dispatcher.emit(Dispatcher.USER_STORE_CHANGE);
  },

  _load(update) {
    if (!this.isLoading && (update || this._state === undefined)){
      this.isLoading = true;
      Jigsaw.User.getInfo(function(response){
        if (response.isSuccess()){
          const user = response.data.user;
          this._updateState(user);
          if (user.needsBookListUpdate){
            this._updateBookList();
          }
          Honeybadger.setContext({
            user_id: user.identifier || ""
          })
        } else if (response.code === 401){
          Dispatcher.emit(Dispatcher.USER_SIGN_OUT);
          if (!Routes.getRoute()[0].match(/login|redirect|logout/)){
            Routes.setRoute('/login');
          }
          Honeybadger.setContext({
            user_id: ""
          })
        }
        this.isLoading = false;
      }.bind(this));
    }
  },

  _updateBookList() {
    if (this._state) { this._state.licenseUpdating = true; }
    this._updateState(this._state);
    Jigsaw.User.updateLicense((response)=>{
      if (response.isSuccess()){
        Dispatcher.emit(Dispatcher.USER_LICENSE_UPDATED);
        if (this._state){
          this._state.needsBookListUpdate = false;
          this._state.licenseUpdating = false;
          this._updateState(this._state);
        }
      }
    });
  },

  _setInfoRouter(info, success, failure){
    Jigsaw.User.setInfo(info, (response)=>{
      if (response.isSuccess()){
        Dispatcher.emit(success);
        this._updateState(response.data);
      }else{
        Dispatcher.emit(failure, response.data);
      }
    });
  },

  init() {
    Dispatcher.on(Dispatcher.USER_SET_INFO, (info)=>{
      this._setInfoRouter(info, Dispatcher.USER_UPDATE_SUCCESS, Dispatcher.USER_UPDATE_FAILURE);
    });
    Dispatcher.on(Dispatcher.USER_CHANGE_PASSWORD, (info)=>{
      this._setInfoRouter(info, Dispatcher.USER_CHANGE_PASSWORD_SUCCESS, Dispatcher.USER_CHANGE_PASSWORD_FAILURE);
    });
    Dispatcher.on(Dispatcher.USER_UPDATE_SECURITY_QUESTION, (info)=>{
      this._setInfoRouter(info, Dispatcher.USER_UPDATE_SECURITY_SUCCESS, Dispatcher.USER_UPDATE_SECURITY_FAILURE);
    });
    Dispatcher.on(Dispatcher.USER_UPDATE_NOTIFICATION, (info)=>{
      this._setInfoRouter(info, Dispatcher.USER_UPDATE_NOTIFICATION_SUCCESS, Dispatcher.USER_UPDATE_NOTIFICATION_FAILURE);
    });
    Dispatcher.on(Dispatcher.USER_SIGN_OUT, (info)=>{
      this._updateState(undefined);
    });
  }

};

UserStore.init();

export default UserStore;
